import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import {
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Autocomplete,
  useMediaQuery,
  Chip,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { axiosInstance } from "../utility/apiInstance";
import { useRole } from "../components/MangeContextProvide";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";

import {
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridSlots,
} from "@mui/x-data-grid";
import toast from "react-hot-toast";
import { GridRenderEditCellParams } from "@mui/x-data-grid";
import {
  hideToggleButton,
  hideToggleButtonEditMode,
  preventAddingDuplocateRow,
} from "../utility/constant";
import InputMask from "react-input-mask";
import { useEffect, useState } from "react";
import { preventAddingDuplocateRowForContact } from "../utility/handleDuplicatedisable";
import SearchInput from "../common/SearchInput";
import { CustomLoadingOverlay, CustomNoRowsOverlay } from "../common/Datagridoverlays";
import { FOOTER_HEIGHT, HEADER_HEIGHT, MAX_GRID_HEIGHT, MIN_GRID_HEIGHT, ROW_ESTIMATE, PAGE_SIZE } from "./Contants/constantValue";
import BulkUploadContactsDialog from "./BulkUploadContactsDialog";

function randomId() {
  return Math.random().toString(36).substr(2, 9);
}
const id = randomId();

// EditToolbar now returns null — Add Record button moved outside DataGrid
function EditToolbar() {
  return null;
}

const CustomOrganizationEditCell = ({
  params,
  orgOptions,
  setOrgOptions,
  axiosInstance,
  handleDebouncedOrgSearch,
}: any) => {
  const [inputValue, setInputValue] = useState(
    typeof params.value === "string" ? params.value : params.value?.name || ""
  );
  const [selectedValue, setSelectedValue] = useState(params.value || null);
  const [loading, setLoading] = useState(false);
  const handleInputChange = (_: any, newInputValue: string) => {
    setInputValue(newInputValue);
    handleDebouncedOrgSearch(newInputValue);
  };

  const handleChange = (_: any, selectedOption: any) => {
    if (selectedOption?.name) {
      setSelectedValue(selectedOption);
      setInputValue(selectedOption.name);
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: selectedOption,
      });
    }
  };

  const handleKeyDown = async (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && inputValue.trim()) {
      event.preventDefault();
      event.stopPropagation();

      const alreadyExists = orgOptions.find(
        (opt: any) =>
          typeof opt === "object" &&
          opt.name.toLowerCase() === inputValue.trim().toLowerCase()
      );

      if (!alreadyExists) {
        try {
          setLoading(true);
          const { data } = await axiosInstance.post(
            "/api/v1/master-contact-organization",
            { name: inputValue.trim() }
          );
          const newOrg = data?.data;
          if (newOrg?.name) {
            setOrgOptions((prev: any) => [...prev, newOrg]);
            setSelectedValue(newOrg);
            setInputValue(newOrg.name);
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newOrg,
            });
          }
        } catch (err) {
        } finally {
          setLoading(false);
        }
      }
    }
  };

  return (
    <Autocomplete
      freeSolo
      fullWidth
      loading={loading}
      options={orgOptions}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.name
      }
      value={selectedValue}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={handleChange}
      noOptionsText={
        inputValue
          ? `Press Enter to create "${inputValue}"`
          : "Start typing to search organizations"
      }
      renderInput={(paramsInput) => (
        <TextField
          className="organizationPading"
          {...paramsInput}
          onKeyDown={handleKeyDown}
          variant="outlined"
          placeholder="Search organization name"
          sx={{
            p: 0,
            "& .MuiInputBase-root": { p: 0 },
            "& input": { p: 0 },
          }}
        />
      )}
    />
  );
};

export default function FullFeaturedCrudGrid() {
  const is1366 = useMediaQuery("(max-width:1366px)");
  const navigate = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  const { globleCustomerId } = useRole() as any;
  const [countryCodes, setcountryCodes] = useState([]);
  const [contryOpenDialog, setContryOpenDialog] = useState(false);
  const [contryDialogMessage, setContryDialogMessage] = useState("");
  const [rowdata, setRowdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});
  const [isAddDisabled, setIsAddDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgOptions, setOrgOptions] = useState<{ _id: string; name: string }[]>([]);
  const [flags, setFlags] = useState<any>([]);
  const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [bulkOpen, setBulkOpen] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    getContactList(debouncedSearch);
  }, [debouncedSearch]);

  const handleLogout = (): void => {
    localStorage.clear();
    navigate("/");
  };

  const getContactList = async (search: string = "") => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/api/v1/contact?search=${encodeURIComponent(search)}`
      );
      const fetchedRows = response?.data?.data;
      const data = fetchedRows.map((row: any, index: number) => {
        const safeId = row?._id || row?.id || `id-${index}`;
        return { ...row, key: safeId, id: safeId, ishideToggle: true, isNew: false };
      });
      setRows(data);
      if (response.data.statusCode === 401) {
        toast.error(response.data.message);
        handleLogout();
      }
      return setLoading(false);
    } catch (err: any) {
      setLoading(false);
    }
  };

  async function getFlagsList() {
    try {
      const { data } = await axiosInstance.get("/api/v1/flags");
      let finaldata = data.data
        .filter((flag: any) => flag.status == "Active")
        .map((flag: any) => {
          let flagId = flag.id;
          delete flag.id;
          return { ...flag, _id: flagId };
        });
      setFlags(finaldata);
    } catch (error) {
      setFlags([]);
    }
  }

  useEffect(() => {
    getFlagsList();
    getCountryCodeList();
    getContactList("");
    fetchOrganizations("");
  }, []);

  const handleAddClick = () => {
    const newId = Math.random();
    setRows((oldRows: any) => {
      if (!preventAddingDuplocateRowForContact(oldRows)) {
        toast.error("You can only submit one record at a time!");
        return oldRows;
      }
      setIsAddDisabled(true);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [newId]: { mode: GridRowModes.Edit, fieldToFocus: "name" },
      }));
      return [
        {
          id: newId,
          salutation: "",
          name: "",
          organizationName: "",
          email: "",
          whatappNumber: "",
          countryCode: "",
          isActive: true,
          isNew: true,
          ishideToggle: false,
        },
        ...oldRows,
      ];
    });
  };

  const handleRowEditStop: GridEventListener<"rowEditStop"> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    setIsAddDisabled(true);
  };

  const handleSaveClick = (id: GridRowId) => async () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    setRows((prev: any) => {
      let array = [...prev];
      let findIndex = array.findIndex((item: any) => item?._id === id);
      if (findIndex !== -1) array[findIndex].ishideToggle = false;
      return array;
    });
    setIsAddDisabled(false);
  };

  const handleDeleteClick = (id: GridRowId, row: any) => async () => {
    const url = `api/v1/contact/delete-contact/${id}`;
    const updatedIsActive = !row.isActive;
    const payload = { isActive: updatedIsActive };
    try {
      const response = await axiosInstance.post(url, payload);
      getContactList("");
      if (response.status === 200) toast.success(response?.data?.message);
    } catch (error: any) {
      toast.error("An error occurred while updating contact status.");
    }
  };

  const handleCancelClick = (id: GridRowId) => async () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
    const editedRow: any = rows.find((row: any) => row.id === id);
    if (editedRow?.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
    if (!editedRow.isNew) {
      setRows((prev: any) => {
        let array = [...prev];
        let findIndex = array.findIndex((item: any) => item?._id === id);
        if (findIndex !== -1) array[findIndex].ishideToggle = true;
        return array;
      });
    }
    setIsAddDisabled(false);
  };

  const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const getAvailableChannels = (row: any) => {
    const channels = [];
    if (row.email) channels.push("email");
    if (row.whatappNumber) channels.push("whatsapp");
    return channels;
  };

  const processRowUpdate = async (newRow: GridRowModel, params: any) => {
    const updatedRow: any = { ...newRow, isNew: false };
    setRowdata(updatedRow);
    const errors = [];

    if (!updatedRow.name) { errors.push("Name cannot be empty"); setIsAddDisabled(true); }
    if (!updatedRow.salutation) { errors.push("Salutation cannot be empty"); setIsAddDisabled(true); }
    if (!updatedRow.email && !updatedRow.whatappNumber) errors.push("Either Email or WhatsApp is required.");
    if (updatedRow.whatappNumber && !updatedRow.countryCode) errors.push("Country Code is required when WhatsApp number is provided.");
    if (updatedRow.email && !gmailRegex.test(updatedRow.email)) { errors.push("Invalid email address1"); setIsAddDisabled(true); }
    if (updatedRow.whatappNumber && updatedRow.whatappNumber.length !== 10) { errors.push("Whatapp number must be of 10 digits"); setIsAddDisabled(true); }
    if (updatedRow.countryCode && !updatedRow.whatappNumber) { errors.push("Country Code cannot be provided without WhatsApp number."); setIsAddDisabled(true); }
    if (!updatedRow.organizationName) { errors.push("Organization Name cannot be empty"); setIsAddDisabled(true); }

    if (errors.length > 0) {
      if (updatedRow?.id === rows?.find((item: any) => item._id === updatedRow._id)?._id) {
        setRows(hideToggleButton(rows, updatedRow?.id));
      }
      errors.forEach((err) => toast.error(err));
      return;
    }

    if (updatedRow?.id < 1) {
      updatedRow.id = id;
      const formData = {
        salutation: updatedRow.salutation,
        name: updatedRow.name,
        email: updatedRow.email,
        masterContactOrganization: updatedRow.organizationName._id.toString(),
        whatappNumber: updatedRow.whatappNumber,
        countryCode: updatedRow?.countryCode || "",
        flags: (updatedRow?.flagsForFilter || []).map((flag: any) => flag._id) || [],
        allowedChannels: updatedRow.allowedChannels,
      };
      try {
        let response = await axiosInstance.post("/api/v1/contact/add-contact", formData);
        if (response.data.statusCode === 201) {
          toast.success(response.data.message);
          const fetchedRows = response?.data?.data;
          const data = fetchedRows.map((row: any, index: number) => {
            const safeId = row?._id || row?.id || `id-${index}`;
            return { ...row, key: safeId, id: safeId, ishideToggle: true, isNew: false };
          });
          setRows(data);
          return updatedRow;
        }
      } catch (err: any) {
        if (updatedRow?.id === rows?.find((item: any) => item?._id === updatedRow?._id)?._id) {
          setRows(hideToggleButtonEditMode(rows, updatedRow));
        }
        const errors = err?.response?.data?.error;
        if (Array.isArray(errors)) {
          errors.forEach((errorObj) => { toast.error(` ${errorObj.message}`); });
        } else if (typeof errors === "object") {
          Object.keys(errors).forEach((field) => { toast.error(`${errors[field]}`); });
        } else if (typeof errors === "string") {
          toast.error(errors);
        }
      }
    } else {
      const getCustomOrg = updatedRow.organizationName?._id || updatedRow.masterContactOrganization?._id;
      let finalFlag =
        typeof updatedRow.flagsForFilter == "string"
          ? updatedRow?.flags.map((flag: any) => flag._id)
          : updatedRow?.flagsForFilter.map((flag: any) => flag._id) || [];
      const formData = {
        salutation: updatedRow.salutation,
        name: updatedRow.name,
        email: updatedRow?.email || "",
        masterContactOrganization: getCustomOrg.toString(),
        whatappNumber: updatedRow.whatappNumber,
        countryCode: updatedRow?.countryCode || "",
        isActive: updatedRow.isActive,
        flags: finalFlag,
        allowedChannels: updatedRow.allowedChannels,
      };
      const url = `api/v1/contact/update-contact/${updatedRow.id}`;
      try {
        const response = await axiosInstance.patch(url, formData);
        const fetchedRows = response?.data?.data;
        const data = fetchedRows.map((row: any, index: number) => {
          const safeId = row?._id || row?.id || `id-${index}`;
          return { ...row, key: safeId, id: safeId, ishideToggle: true, isNew: false };
        });
        setRows(data);
        toast.success(data?.message || "Contact updated successfully");
        return updatedRow;
      } catch (err: any) {
        if (updatedRow.id === rows?.find((item: any) => item._id === updatedRow._id)?._id) {
          setRows((prevRows: any) => hideToggleButtonEditMode(prevRows, updatedRow));
        }
        if (Array?.isArray(err.response?.data?.error)) {
          err?.response?.data?.error?.forEach((error: any) => { toast.error(`${error?.message}`); });
        } else {
          const errorData = err?.response?.data?.error;
          if (typeof errorData === "object" && errorData !== null) {
            toast.error(Object.values(errorData).join(", ") || "An error occurred while updating the customer.");
            setRows((prevRows: any) => hideToggleButtonEditMode(prevRows, updatedRow));
          } else {
            toast.error(errorData || "An error occurred while updating the customer.");
            setRows((prevRows: any) => hideToggleButtonEditMode(prevRows, updatedRow));
          }
        }
      }
    }
  };

  const getCountryCodeList = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/country/counry-code");
      if (response.data && response.data.success) {
        setcountryCodes(
          response.data.data?.map((item: any) => ({
            ...item,
            lable: item?.name,
            value: item?.calling_code,
          }))
        );
      }
    } catch (error: any) { }
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationChange = (paginationModel: any) => {
    setCurrentPage(paginationModel.page);
  };

  const handleDialogOpen = (message: React.SetStateAction<string>) => {
    setContryDialogMessage(message);
    setContryOpenDialog(true);
  };

  const handleDialogClose = () => {
    setContryOpenDialog(false);
  };

  const fetchOrganizations = async (query: string) => {
    try {
      const { data } = await axiosInstance.get(
        `/api/v1/master-contact-organization?search=${query}`
      );
      setOrgOptions(data?.data || []);
    } catch (err) {
      setOrgOptions([]);
    }
  };

  const handleDebouncedOrgSearch = (inputValue: string) => {
    if (debounceTimer) clearTimeout(debounceTimer);
    const newTimer = setTimeout(() => {
      fetchOrganizations(inputValue);
    }, 500);
    setDebounceTimer(newTimer);
  };

  const gridHeight = Math.min(
    MAX_GRID_HEIGHT,
    Math.max(
      MIN_GRID_HEIGHT,
      HEADER_HEIGHT + FOOTER_HEIGHT + Math.min(Math.max(rows.length, 1), PAGE_SIZE) * ROW_ESTIMATE
    )
  );

  const columns: GridColDef[] = [
    {
      field: "s_no",
      headerName: "S.No.",
      sortable: true,
      editable: false,
      // width: 70,
      width: is1366 ? 60 : 70,
      disableColumnMenu: true,
    },

    {
      field: "salutation",
      headerName: "Salutation",
      sortable: true,
      editable: true,
      width: is1366 ? 100 : 120,

      renderEditCell: (params) => (
        <Select
          value={params.value || ""}
          onChange={(event) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: event.target.value,
            })
          }
          size="small"
          fullWidth
          sx={{
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ddd",
            },

            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ffb310",
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ffb310",
              borderWidth: "2px",
            },

            "& .MuiSelect-select": {
              padding: "8px 12px",
              fontSize: "14px",
            },
          }}
        >
          <MenuItem value="Mr">Mr</MenuItem>
          <MenuItem value="Mrs">Mrs</MenuItem>
          <MenuItem value="Ms">Ms</MenuItem>
        </Select>
      ),
    },

    {
      field: "name",
      headerName: "Name",
      sortable: true,
      editable: true,
      width: is1366 ? 120 : 150,

      renderEditCell: (params) => (
        <TextField
          value={params.value || ""}
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              fontSize: "14px",
              backgroundColor: "#fff",

              "& fieldset": {
                borderColor: "#ddd",
              },

              "&:hover fieldset": {
                borderColor: "#ffb310",
              },

              "&.Mui-focused fieldset": {
                borderColor: "#ffb310",
                borderWidth: "2px",
              },
            },

            "& .MuiInputBase-input": {
              padding: "8px 12px",
            },
          }}
        />
      ),
    },

    {
      field: "organizationName",
      headerName: "Organization",
      editable: true,
      // width: 200,
      width: is1366 ? 150 : 200,
      renderEditCell: (params) => (
        <CustomOrganizationEditCell
          params={params}
          orgOptions={orgOptions}
          setOrgOptions={setOrgOptions}
          axiosInstance={axiosInstance}
          handleDebouncedOrgSearch={handleDebouncedOrgSearch}
        />
      ),
    },

    {
      field: "countryCode",
      headerName: "Country Code",
      //width: 120,
      width: is1366 ? 100 : 120,
      editable: true,
      align: "right",
      renderCell: (params) => (params?.row.countryCode ? `+${params?.row.countryCode}` : ""),
      renderEditCell: (params: GridRenderEditCellParams) => (
        <Autocomplete
          value={
            countryCodes
              .map((item: any) => ({ label: item.value, value: item.calling_code }))
              .find((item: any) => item.label === params.value) || null
          }
          options={
            countryCodes?.map((country: any) => ({ label: country.value, value: country.value })) || []
          }
          getOptionLabel={(option) => `+${option.label}`}
          sx={{ width: "150%" }}
          onChange={(event, newValue) => {
            const value = newValue?.value;
            const checkstatus = countryCodes.find((item: any) => item?.calling_code === value) as any;
            if (checkstatus !== undefined && !checkstatus?.whatsapp_status) {
              handleDialogOpen(
                "The selected country code is not active for WhatsApp messages. If you wish to get this country activated, reach out to us over email."
              );
              return;
            }
            params.api.setEditCellValue({ id: params.id, field: "countryCode", value: value });
          }}
          renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
        />
      ),
    },
    {
      field: "whatappNumber",
      headerName: "whatapp No.",
      sortable: true,
      editable: true,
      // width: 130,
      width: is1366 ? 100 : 130,
      renderEditCell: (params) => {
        const handlePhoneNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value });
        };
        return (
          <InputMask mask="9999999999" maskChar={null} value={params.value || ""} onChange={handlePhoneNumberChange}>
            {(inputProps: any) => <TextField {...inputProps} fullWidth inputProps={{ maxLength: 13 }} />}
          </InputMask>
        );
      },
    },
    {
      field: "email",
      headerName: "Email ID",
      sortable: true,
      editable: true,
      width: is1366 ? 170 : 250,

      renderEditCell: (params) => (
        <TextField
          value={params.value || ""}
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
          type="email"
          placeholder="Enter email"
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              fontSize: "14px",
              backgroundColor: "#fff",

              "& fieldset": {
                borderColor: "#ddd",
              },

              "&:hover fieldset": {
                borderColor: "#ffb310",
              },

              "&.Mui-focused fieldset": {
                borderColor: "#ffb310",
                borderWidth: "2px",
              },
            },

            "& .MuiInputBase-input": {
              padding: "8px 12px",
            },
          }}
        />
      ),
    },

    // ── Flags column ─────────────────────────────────────────────
    {
      field: "flagsForFilter",
      headerName: "Flags",
      // width: 280,
      width: is1366 ? 180 : 260,
      sortable: true,
      filterable: true,
      editable: true,

      // ✅ FIX: show full chip labels, wrap into rows, no truncation
      renderCell: (params) => {
        const flagList: any[] = params.row.flags || [];
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              padding: "6px 0",
              alignItems: "center",
              width: "100%",
            }}
          >
            {flagList.map((flag: any) => (
              <Chip
                key={flag._id || flag.id}
                label={flag.name}
                size="small"
                sx={{
                  backgroundColor: "#e8f4fd",
                  color: "#1565c0",
                  fontWeight: 600,
                  borderRadius: "6px",
                  height: "22px",
                  fontSize: "0.75rem",
                  maxWidth: "none",         // ✅ no truncation
                  "& .MuiChip-label": {
                    overflow: "visible",    // ✅ full text visible
                    whiteSpace: "nowrap",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  },
                }}
              />
            ))}
          </div>
        );
      },

      renderEditCell: (params) => {
        const { id, api } = params;
        const selectedFlags = Array.isArray(params.value) ? params.value : params.row.flags || [];
        const handleChange = (event: any, newValue: any[]) => {
          api.setEditCellValue({ id, field: "flagsForFilter", value: newValue });
        };
        return (
          <Autocomplete
            multiple
            value={selectedFlags}
            options={flags || []}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            onChange={handleChange}
            renderTags={(selected, getTagProps) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "4px",
                  width: "100%",       // ⬅️ constrain to cell width, not auto
                  maxWidth: "100%",
                  py: "4px",
                  overflow: "hidden",  // ⬅️ don't let chips push the cell wider
                }}
              >
                {selected.map((flag, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={flag._id}
                    label={flag.name}
                    sx={{
                      backgroundColor: "#e8f4fd",
                      color: "#1565c0",
                      fontWeight: 500,
                      borderRadius: "4px",
                      height: "24px",
                      fontSize: "0.75rem",
                      maxWidth: "100%",     // ⬅️ chip can't exceed container width
                      width: "fit-content",
                      "& .MuiChip-label": {
                        overflow: "hidden",        // ⬅️ truncate instead of overflowing
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",  // long names get "..." instead of forcing scroll
                        paddingLeft: "8px",
                        paddingRight: "4px",
                      },
                    }}
                  />
                ))}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select Flags"
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  style: {
                    paddingTop: 6,
                    paddingBottom: 6,
                    whiteSpace: "normal",
                    overflowY: "auto",
                    overflowX: "hidden",  // ⬅️ block horizontal scroll on the input itself
                    maxHeight: 200,
                    minWidth: 140,
                  },
                }}
              />
            )}
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 140,
              overflowX: "hidden",   // ⬅️ block horizontal scroll on the autocomplete root
              "& .MuiAutocomplete-inputRoot": {
                flexWrap: "wrap",
                alignItems: "flex-start",
                paddingTop: "4px !important",
                paddingBottom: "4px !important",
                paddingLeft: "0px !important",
                minHeight: "auto",
                maxWidth: "100%",
                overflowX: "hidden",
              },
            }}
          />
        );
      },
    },

    // ── Allowed Channels column ───────────────────────────────────
    {
      field: "allowedChannels",
      headerName: "Allowed Channels",
      // width: 200,
      width: is1366 ? 140 : 200,
      sortable: true,
      filterable: true,
      editable: true,

      // ✅ FIX: show full chip labels, wrap into rows, no truncation
      renderCell: (params) => {
        const channelList: any[] = params.row.allowedChannels || [];
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              padding: "6px 0",
              alignItems: "center",
              width: "100%",
            }}
          >
            {channelList.map((channel: any, index: number) => (
              <Chip
                key={index}
                label={channel}
                size="small"
                sx={{
                  backgroundColor: "#e8f5e9",
                  color: "#2e7d32",
                  fontWeight: 600,
                  borderRadius: "6px",
                  height: "22px",
                  fontSize: "0.75rem",
                  maxWidth: "none",         // ✅ no truncation
                  "& .MuiChip-label": {
                    overflow: "visible",    // ✅ full text visible
                    whiteSpace: "nowrap",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  },
                }}
              />
            ))}
          </div>
        );
      },

      renderEditCell: (params) => {
        const { id, api } = params;
        const selectedChannels = Array.isArray(params.value)
          ? params.value
          : params.row.allowedChannels || [];
        const handleChange = (event: any, newValue: any[]) => {
          api.setEditCellValue({ id, field: "allowedChannels", value: newValue });
        };
        const allowed = getAvailableChannels(params.row);
        const filteredOptions = allowed.filter((opt) => !selectedChannels.includes(opt));
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",   // ⬅️ pin content to top of the (tall) cell
              width: "100%",
              height: "100%",
              pt: "6px",
            }}
          >
            <Autocomplete
              multiple
              value={selectedChannels}
              options={filteredOptions}
              getOptionLabel={(option) => option}
              isOptionEqualToValue={(option, value) => option === value}
              onChange={handleChange}
              slotProps={{
                popper: { style: { zIndex: 1400 } },
              }}
              renderTags={(selected, getTagProps) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "4px",
                    width: "100%",
                    maxWidth: "100%",
                    py: "2px",
                    overflow: "hidden",
                  }}
                >
                  {selected.map((channel, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={index}
                      label={channel}
                      size="small"
                      sx={{
                        backgroundColor: "#e8f5e9",
                        color: "#2e7d32",
                        fontWeight: 500,
                        borderRadius: "4px",
                        height: "22px",
                        fontSize: "0.75rem",
                        maxWidth: "100%",
                        "& .MuiChip-label": {
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          paddingLeft: "8px",
                          paddingRight: "4px",
                        },
                      }}
                    />
                  ))}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder={selectedChannels.length ? "" : "Select Channels"}
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      paddingTop: 4,
                      paddingBottom: 4,
                      whiteSpace: "normal",
                      overflowY: "auto",
                      overflowX: "hidden",
                      maxHeight: 100,
                      minWidth: 160,
                    },
                  }}
                />
              )}
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 160,
                overflowX: "hidden",
                // ⬅️ this is the actual fix: stop DataGrid from forcing full-height stretch
                "&.MuiAutocomplete-root .MuiInputBase-root": {
                  height: "auto !important",
                },
                "& .MuiAutocomplete-inputRoot": {
                  flexWrap: "wrap",
                  alignItems: "center",
                  paddingTop: "2px !important",
                  paddingBottom: "2px !important",
                  paddingLeft: "0px !important",
                  minHeight: "auto",
                  maxWidth: "100%",
                  overflowX: "hidden",
                },
              }}
            />
          </Box>
        );
      },
    },

    {
      field: "isActive",
      headerName: "Status",
      filterable: false,
      sortable: true,
      //width: 110,
      width: is1366 ? 80 : 110,
      renderCell: (params) => (params.row.isActive ? "Active" : "Inactive"),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: is1366 ? 110 : 150,
      // ...(isBigScreen ? { flex: 1, width: 150 } : { flex: 0 }),
      cellClassName: "actions",
      getActions: ({ id, row }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const canShowActions = globleCustomerId === row?.customerId;
        if (!canShowActions && !row?.isNew) return [];
        if (isInEditMode || row?.isNew) {
          return [
            <GridActionsCellItem
              key={`save-${id}`}
              icon={<SaveIcon />}
              label="Save"
              sx={{ color: "primary.main" }}
              onClick={handleSaveClick(id)}
              className="iconMilestone_save"
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              key={`cancel-${id}`}
              label="Cancel"
              className="iconMilestone_close"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }
        if (!row?.ishideToggle) return [<></>];
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            disabled={!row.isActive}
            key={`edit-${id}`}
            label="Edit"
            className="iconMilestone_edit"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            key={`delete-${id}`}
            icon={
              <FormControlLabel
                control={
                  <Switch
                    className="thinSwitch"
                    checked={row.isActive}
                    sx={{
                      "& .MuiSwitch-switchBase": {
                        "&.Mui-checked": { color: "green", "& + .MuiSwitch-track": { backgroundColor: "green" } },
                        "&.Mui-unchecked": { color: "#ff0000", "& + .MuiSwitch-track": { backgroundColor: "red" } },
                      },
                    }}
                  />
                }
                label=""
              />
            }
            label="Delete"
            onClick={handleDeleteClick(id, row)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <>
      <div className="flexHeading">
        <div className="old_dashboard_title">
          <h1 className="text-2xl font-bold text-gray-700">
            Manage Contacts
          </h1>
        </div>
      </div>

      <div className="whiteBox relative manageContactsMain">
        {/* ✅ Search + Add Record on same horizontal line */}


       
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            marginBottom: "16px",
          }}
        >
          <SearchInput
            placeholder="Search Contacts"
            value={searchQuery}
            onChange={setSearchQuery}
            width={400}
          />

          {/* both buttons grouped together on the right */}
          {currentPage === 0 && (
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Button
                className={clsx("btnTheme btnPadding", {
                  "opacity-50 cursor-not-allowed": isAddDisabled,
                })}
                color="primary"
                onClick={handleAddClick}
                disabled={isAddDisabled}
              >
                Add Contact
              </Button>

              <Button
                className="btnTheme btnPadding"
                color="primary"
                onClick={() => setBulkOpen(true)}
              >
                Bulk Upload
              </Button>
            </div>
          )}
        </div>
        <Box
          sx={{
            height: gridHeight,
            width: "100%",
            "& .actions": { color: "text.secondary" },
            "& .textPrimary": { color: "text.primary" },
            "& .new-row-border": { border: "2px solid green", borderRadius: "10px" },
            boxShadow: "0 1px 2px rgba(0, 0, 0, .06), 0 2px 8px rgba(0, 0, 0, .05)",
          }}
        >
          <DataGrid
            rows={rows.map((row: any, index) => ({
              ...row,
              key: row?.id || index + 1,
              id: row?.id || index + 1,
              name: row?.name,
              number: row?.contactInfo?.phone,
              email: row?.email,
              organization: row?.organizationName || "",
              countryCode: row?.countryCode,
              whatappNumber: row?.whatappNumber,
              s_no: index + 1,
              // ✅ Keep flagsForFilter as array so renderCell can use it
              flagsForFilter: Array.isArray(row?.flags) ? row.flags : [],
            }))}
            columns={columns}
            loading={loading}
            getRowHeight={() => "auto"}
            getEstimatedRowHeight={() => 52}
            editMode="row"

            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={(error) => { }}
            onPaginationModelChange={handlePaginationChange}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            pageSizeOptions={[10]}
            slots={{
              toolbar: EditToolbar as GridSlots["toolbar"],
              loadingOverlay: CustomLoadingOverlay,
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            slotProps={{
              loadingOverlay: { message: "Loading contacts..." },
              noRowsOverlay: { message: "No contacts found" },
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) event.defaultMuiPrevented = true;
            }}
            onCellKeyDown={(params, event) => {
              if (event.key === "Enter") {
                event.stopPropagation();
                event.preventDefault();
              }
            }}
            sx={{
              // Keeps the loading spinner / "No rows" message from collapsing
              // into a tiny sliver when autoHeight has no row data to size against.
              "--DataGrid-overlayHeight": "300px",
            }}
            autoHeight={false}
            rowHeight={38}
            columnHeaderHeight={42}
          />
        </Box>

        <Dialog
          open={contryOpenDialog}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            "& .MuiDialog-container": { alignItems: "flex-start" },
            "& .MuiPaper-root": { mt: 2 },
          }}
        >
          <DialogTitle id="alert-dialog-title">Inactive Country Code</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {contryDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleDialogClose}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <BulkUploadContactsDialog
        open={bulkOpen}
        onClose={() => setBulkOpen(false)}
        onCompleted={() => getContactList("")}
      />
    </>
  );
}